import { useState, useRef } from "react";
import { DatePicker } from "rsuite";
import { FaCalendar } from "react-icons/fa";
import "rsuite/dist/rsuite.min.css";

const DatePicker1 = ({ onSendData, initialValue, placeLetter, enabled }) => {
  const [show1, setShowDatePicker] = useState(false);
  const [dateRange, setDateRange] = useState(initialValue);
  const [resetDate, setResetDate] = useState(true);
  const datePickerContainerRef = useRef(null);

  const reset = () => {
    setDateRange(new Date());
    setResetDate(true);
  };

  const formatDate = (date) => {
    if (!date) return "";
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  return (
    <div>
      <style>
        {`
                .rs-picker-input-group {
                    visibility: hidden !important;
                }
                `}
      </style>
      <div className="w-full">
        <div>
          <div
            ref={datePickerContainerRef}
            className={`w-full ${show1 && "relative"}`}
          >
            <span>
              <div className="w-full h-[38px] bg-white text-gray-700 border border-gray-700 rounded flex group items-center">
                <div
                  onClick={() => enabled && setShowDatePicker(true)}
                  className="w-full h-full flex"
                >
                  <div className="flex flex-col justify-center">
                    <FaCalendar className="w-4 h-4 ml-3 text-gray-700" />
                  </div>
                  <input
                    placeholder={placeLetter}
                    className="w-[80%] h-full outline-none text-center text-gray-700 bg-transparent"
                    value={formatDate(dateRange)}
                    readOnly
                  />
                </div>
                {dateRange.length > 1 && (
                  <div
                    onClick={reset}
                    className="h-[40px] w-[40px] flex flex-col justify-center cursor-pointer"
                  >
                    <svg
                      className="w-4 h-4 ml-3 opacity-0 group-hover:opacity-100 transition-opacity duration-200 text-gray-200"
                      focusable="false"
                      viewBox="0 0 24 24"
                      data-testid="HighlightOffIcon"
                      title="HighlightOff"
                      fill="currentColor"
                    >
                      <path d="M14.59 8 12 10.59 9.41 8 8 9.41 10.59 12 8 14.59 9.41 16 12 13.41 14.59 16 16 14.59 13.41 12 16 9.41zM12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2m0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8"></path>
                    </svg>
                  </div>
                )}
              </div>
            </span>
            {show1 && (
              <div className="absolute top-[10px] left-[20px]">
                <DatePicker
                  placement="bottom"
                  format="yyyy-MM-dd"
                  defaultValue={new Date()}
                  value={dateRange}
                  showMeridiem={false}
                  caretAs={FaCalendar}
                  open={true}
                  onChange={(newRange) => {
                    setDateRange(newRange);
                    setResetDate(false);
                    onSendData(formatDate(newRange));
                  }}
                  onClose={() => setShowDatePicker(false)}
                  container={datePickerContainerRef.current}
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default DatePicker1;
